module.exports = __webpack_public_path__ + "img/section33.f4e7fc1e.png";